<h1 class="harp-card-title">PIV Card</h1>
<p>
  To start using PIV card, you must first log in at least one time using a CMS
  issued EUA username and password. If you are having trouble, please go to
  <a href="https://eua.cms.gov" target="_blank">eua.cms.gov</a> to reset your
  username and password. Please note that once logged in, you may need to
  re-request user roles when using EUA. For more information, please view the
  <a href="https://qnetconfluence.cms.gov/display/HS/HARP" target="_blank"
    >HARP User Guide</a
  >.
</p>
<a
  class="back-to-account-recovery"
  [routerLink]="['/login/account-recovery']"
  queryParamsHandling="merge"
>
  <strong class="icon ion-md-arrow-round-back"></strong> Back to Account
  Recovery</a
>
